import { PaletteMode } from '@mui/material';
import { ChronosphereColorPalette, blue, unityBlue } from '../colors';
import { GetThemeOptions } from '../../theme';

export const infoColor = (mode: PaletteMode, opts: GetThemeOptions): ChronosphereColorPalette => {
  if (opts.panwRebrandStubYear) {
    return mode === 'light'
      ? {
          main: unityBlue[500],
          highContrast: unityBlue[700],
          lowContrast: unityBlue[100],
        }
      : {
          main: unityBlue[400],
          highContrast: unityBlue[100],
          lowContrast: unityBlue[800],
        };
  }

  return mode === 'light'
    ? {
        main: blue[500],
        highContrast: blue[700],
        lowContrast: blue[100],
      }
    : {
        main: blue[400],
        highContrast: blue[100],
        lowContrast: blue[800],
      };
};
